module.exports = __webpack_public_path__ + "media/icons/upload_alt-5bf581c6.svg";